import React from 'react'

export default function Footer(){
    return(
    <div>
        <div className='hidden lg:block text-center p-[50px] mt-[5px]'></div>
        <div className='hidden lg:block text-center p-[50px] mt-[5px]'></div>
        <div className='hidden lg:block text-center p-[50px] mt-[50px]'>&copy; 2025 Angga Dwi Kurniawann</div>
    </div>
    );

}
